import React from 'react';

const Pass: React.FC = () => {
  return (
    <svg viewBox="0 0 64 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M54.5904 17.4198L60.1504 20.7598L63.8904 30.9198L11.0004 49.7398L7.61035 40.6298L10.3004 34.3698L4.11035 31.2698L0.110352 20.2698L52.6003 0.259766L56.6804 11.3498L54.5904 17.4198ZM19.7004 16.9098L17.6104 17.6798L19.6104 23.1098L21.7004 22.3398L19.7004 16.9098ZM23.0004 25.7398L20.8604 26.5098L22.9004 31.9398L25.0004 31.1698L23.0004 25.7398ZM24.0004 34.9998L26.0004 40.4298L28.0904 39.6598L26.0904 34.2298L24.0004 34.9998ZM41.5242 30.1404L44.6971 30.7435L47.239 25.5657L44.5136 23.6626L43.5062 25.6422L41.6193 20.0829L38.9533 19.589L36.4951 24.604L37.5194 15.3928L34.3976 14.8032L30.2997 19.9503L32.8947 21.7751L33.7368 20.5501L32.4341 33.2442L35.5509 33.8664L39.8243 25.1617L41.5242 30.1404Z"
      />
    </svg>
  );
};

export { Pass };
